export default {
	people: {
		title: "People",
	},
	spiritualManagement: {
		title: "Spiritual Management",
	},
	ritualManagement: {
		title: "Ritual Management",
	},
	templeManagement: {
		title: "Temple Management",
	},
	tools: {
		title: "Tools",
	},
};
